/**
 * 信息流相关的工具函数函数，可能有副作用，其他模块勿引入
 */

import { query } from './utils';

export function getAdShield(val) {
  let adShield = query.get(val);
  if (adShield) {
    adShield = adShield.split('_');
  }
  return adShield || [];
}

export const brandName = window.atob('b3Bwbw==');

export const getCommentEnv = function () {
  return window.pageData?.COMMON?.COMMENT_ENV || 'local';
};

export const getEnv = function () {
  const defaultEnv = 'production';
  const env =
    query.get(brandName + 'env') ||
    query.get('openv') ||
    window.pageData?.COMMON?.ENV ||
    process.env.NODE_ENV;

  return ['production', 'test', 'dev', 'development'].includes(env)
    ? env
    : defaultEnv;
};

export function getSourceEn(docInfo = window[brandName].DOCINFO || {}) {
  return docInfo.sourceEn;
}

/**
 * 替换URL中的path
 * @param {String} url
 * @param {String} val
 * @returns
 */
export function replaceUrlPath(url, val) {
  if (!url || typeof url !== 'string' || !val || typeof val !== 'string')
    return url;
  return url.replace(
    /\/\/(?:news-test-cpc\.wanyol\.com|news\.heytapdownload\.com)\/(\S+)\//,
    (uri, path) => {
      return uri.replace(path, val);
    },
  );
}

export const getDocId = function () {
  const docId =
    window[brandName]?.DOCINFO?.docId || window.pageData?.DOCINFO?.docId || '';

  return (
    docId ||
    query.get('base62Id') ||
    query.get(brandName + 'Id') ||
    query.get('docId') ||
    query.get('docid')
  );
};

export const getTopicId = function () {
  const arr = window.location.pathname.split('/');
  const setTopicId = arr[arr.length - 1].split('.')[0];
};

export const getResourceId = function () {
  const docInfo = window[brandName].DOCINFO || {};

  return docInfo.resourceId;
};

export const getSource = function () {
  const docInfo = window[brandName].DOCINFO || {};
  return (
    docInfo.sourceEn ||
    docInfo.source ||
    query.get('sourceMedia') ||
    ''
  ).toLowerCase();
};

// 自执行闭包函数
const fixDocInfo = (function () {
  window[brandName] = window[brandName] || {};

  const docInfo = window[brandName].DOCINFO || {};

  // fix 人民网
  if (!docInfo.sourceEn && docInfo.source === '人民资讯') {
    docInfo.sourceEn = 'people';
  }
  if (!docInfo.sourceEn && docInfo.source === '橘子娱乐') {
    docInfo.sourceEn = 'happyjuzi';
  }

  window[brandName].DOCINFO = docInfo;
  window[brandName].DOCINFO.docId = getDocId();
  window[brandName].DOCINFO.source = getSource();
  window[brandName].env = getEnv();
  window[brandName].DOCINFO.topicId = getTopicId();
})();
